import React, { useState, useEffect } from 'react';
import { Target, BarChart3, Wallet, Blocks, Scale, Settings, ArrowRight } from 'lucide-react';
import { services as defaultServices } from '../data/mock';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const iconMap = {
  Target,
  BarChart3,
  Wallet,
  Blocks,
  Scale,
  Settings,
};

const Services = () => {
  const [services, setServices] = useState(defaultServices);
  const [header, setHeader] = useState({
    label: "Our Services",
    title: "Comprehensive Business Solutions",
    description: "From strategic consulting to blockchain implementation, we provide the expertise and resources your business needs to thrive."
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesRes, headerRes] = await Promise.all([
          axios.get(`${API}/content/services`),
          axios.get(`${API}/content/section-headers/services`)
        ]);
        if (servicesRes.data && servicesRes.data.length > 0) {
          setServices(servicesRes.data.filter(item => item.visible !== false));
        }
        if (headerRes.data) {
          setHeader(headerRes.data);
        }
      } catch (error) {
        console.log('Using default services');
      }
    };
    fetchData();
  }, []);

  return (
    <section id="services" className="py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-8">
          <span className="inline-block text-gold-600 font-semibold text-sm tracking-wider uppercase mb-4">
            {header.label}
          </span>
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-navy-900 mb-6">
            {header.title}
          </h2>
          <p className="text-base text-gray-600 leading-relaxed">
            {header.description}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="panel-flair group bg-white rounded-xl overflow-hidden border-2 border-slate-200/70 hover:border-gold-400 transition-all duration-300 hover:-translate-y-1 flex flex-col h-full"
              >
                <div className="p-4 flex flex-col flex-1">
                  {/* Header row: icon + title side-by-side */}
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 bg-gradient-to-br from-navy-800 to-navy-900 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                      {IconComponent && <IconComponent className="w-5 h-5 text-gold-400" />}
                    </div>
                    <h3 className="text-base font-bold text-navy-900 leading-tight group-hover:text-gold-600 transition-colors">
                      {service.title}
                    </h3>
                  </div>

                  <p className="text-gray-600 text-sm leading-snug mb-2">
                    {service.description}
                  </p>

                  {/* Learn More Link */}
                  <a
                    href="#contact"
                    className="mt-auto pt-2 inline-flex items-center text-gold-600 font-semibold text-sm hover:text-gold-700 transition-colors"
                  >
                    <ArrowRight className="w-3.5 h-3.5 mr-1.5" />
                    Learn More
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
